import type { GutXAxisFlagLevel } from '@repo/types';
import c from 'classnames';
import { Typography } from '../Typography/Typography';
import styles from './GutXAxisFlagKey.module.css';

export interface GutXAxisFlagKeyProps {
  flagLevel: GutXAxisFlagLevel;
  small?: boolean;
}

/** A flag level's colour swatch beside its label. The label is capitalised in CSS. */
export const GutXAxisFlagKey = ({ flagLevel, small }: GutXAxisFlagKeyProps) => (
  <div className={c(styles.flagKey, small && styles.sm)}>
    <div className={c(styles.flagColor, styles[flagLevel])} />
    <Typography className={styles.flagLabel} variant='body-xs'>
      {flagLevel} number of flags
    </Typography>
  </div>
);

export default GutXAxisFlagKey;
